import types from './types';

const INITIAL_STATE = {
    billingInfo: null,
    loading: true
};

const billingPageReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.SET_BILLING_INFO:
            return {
                ...state,
                billingInfo: action.payload
            };
        case types.SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case types.RESET_BILLING_INFO:
            return INITIAL_STATE;
        default:
            return state;
    }
};

export default billingPageReducer;
